import { render, staticRenderFns } from "./Perform.vue?vue&type=template&id=234bb914&"
import script from "./Perform.vue?vue&type=script&lang=js&"
export * from "./Perform.vue?vue&type=script&lang=js&"
import style0 from "./Perform.vue?vue&type=style&index=0&class=scss&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports